import { diacritics } from './diacritics.js';
export function normalizeSync(input) {
    if ('string' !== typeof (input)) {
        throw new TypeError(`Expected 'input' to be of type string, but received '${input}'`);
    }
    if (!input.length)
        return input;
    return input.replace(/(\S)/g, (_, s) => {
        const normalized = diacritics.find(n => new RegExp(n.diacritics).test(s));
        return normalized == null ? s : normalized.letter;
    });
}
//# sourceMappingURL=normalize-sync.js.map